export default __webpack_public_path__ + "static/media/certifiedXResearch.83a7c1d0.png";